import { createSelector } from "@reduxjs/toolkit";

const selectUser = (state) => state.user;

// Selector to check if both country and immigrantStatus are selected
export const hasCountryAndStatusSelector = createSelector(selectUser, (user) => {
  // console.log(user.country + "  " + user.immigrantStatus);
  return user.country && user.immigrantStatus;
});
